export const MANAGE_RECIPE_FETCHING = 'MANAGE_RECIPE_FETCHING';
export const MANAGE_RECIPE_FETCH_ERROR = 'MANAGE_RECIPE_FETCH_ERROR';
export const MANAGE_RECIPE_CLEAR_ERRORS = 'MANAGE_RECIPE_CLEAR_ERRORS';
export const MANAGE_RECIPE_FETCH_INFO = 'MANAGE_RECIPE_FETCH_INFO';
export const MANAGE_RECIPE_CLEAR_INFO = 'MANAGE_RECIPE_CLEAR_INFO';
export const MANAGE_RECIPE_FETCH_SUCCESS = 'MANAGE_RECIPE_FETCH_SUCCESS';
export const MANAGE_RECIPE_SET_CONVERT_TO_INGREDIENT_SUCCESSFUL =
  'MANAGE_RECIPE_SET_CONVERT_TO_INGREDIENT_SUCCESSFUL';

export const MANAGE_RECIPE_GET_NUTRITION_FACTS_FETCHING =
  'MANAGE_RECIPE_GET_NUTRITION_FACTS_FETCHING';
export const MANAGE_RECIPE_GET_NUTRITION_FACTS_ERROR =
  'MANAGE_RECIPE_GET_NUTRITION_FACTS_ERROR';

export const MANAGE_RECIPE_DELETE_RECIPE_LOADING =
  'MANAGE_RECIPE_DELETE_RECIPE_LOADING';
export const MANAGE_RECIPE_DELETE_RECIPE_SUCCESS =
  'MANAGE_RECIPE_DELETE_RECIPE_SUCCESS';
export const MANAGE_RECIPE_DELETE_RECIPE_ERROR =
  'MANAGE_RECIPE_DELETE_RECIPE_ERROR';
export const MANAGE_RECIPE_SET_SAVE_SUCCESSFUL =
  'MANAGE_RECIPE_SET_SAVE_SUCCESSFUL';
export const MANAGE_RECIPE_SET_DELETE_SUCCESSFUL =
  'MANAGE_RECIPE_SET_DELETE_SUCCESSFUL';
export const MANAGE_RECIPE_SAVE_NEW_RECIPE_SUCCESS =
  'MANAGE_RECIPE_SAVE_NEW_RECIPE_SUCCESS';

export const MANAGE_RECIPE_WRITE_INACTIVE_LOADING =
  'MANAGE_RECIPE_WRITE_INACTIVE_LOADING';
export const MANAGE_RECIPE_WRITE_INACTIVE_SUCCESS =
  'MANAGE_RECIPE_WRITE_INACTIVE_SUCCESS';
export const MANAGE_RECIPE_WRITE_INACTIVE_ERROR =
  'MANAGE_RECIPE_WRITE_INACTIVE_ERROR';
export const MANAGE_RECIPE_SET_INACTIVE_SUCCESSFUL =
  'MANAGE_RECIPE_SET_INACTIVE_SUCCESSFUL';
export const MANAGE_RECIPE_SET_SHOW_INGREDIENT_MODAL =
  'MANAGE_RECIPE_SET_SHOW_INGREDIENT_MODAL';

export const MANAGE_RECIPE_DUPLICATE_RECIPE_LOADING =
  'MANAGE_RECIPE_DUPLICATE_RECIPE_LOADING';
export const MANAGE_RECIPE_DUPLICATE_RECIPE_ERROR =
  'MANAGE_RECIPE_DUPLICATE_RECIPE_ERROR';
export const MANAGE_RECIPE_SET_DUPLICATE_SUCCESSFUL =
  'MANAGE_RECIPE_SET_DUPLICATE_SUCCESSFUL';



// WEBPACK FOOTER //
// ./src/pages/managerecipe/state/editrecipe/types.js